import { useRef, useEffect } from 'react';

const IMAGES = {
  1: 'https://customer-assets.emergentagent.com/job_espresso-site-9/artifacts/9h5sqabf_Affiches%20resto.png',
  2: 'https://customer-assets.emergentagent.com/job_espresso-site-9/artifacts/31l6q3mb_Affiches%20resto%202.png',
};

export default function ParallaxStrip({ variant = 1 }) {
  const containerRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const img = imgRef.current;
    if (!container || !img) return;

    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      img.style.transform = 'none';
      return;
    }

    let ticking = false;

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const rect = container.getBoundingClientRect();
          const wh = window.innerHeight;

          if (rect.top < wh && rect.bottom > 0) {
            const progress = (wh - rect.top) / (wh + rect.height);
            const yOffset = (progress - 0.5) * 100;
            img.style.transform = `translate3d(0, ${yOffset}px, 0)`;
          }

          ticking = false;
        });

        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      ref={containerRef}
      data-testid={`parallax-strip-${variant}`}
      className="relative w-full overflow-hidden h-[260px] sm:h-[320px] md:h-[50vh]"
    >
      <img
        ref={imgRef}
        src={IMAGES[variant]}
        alt=""
        className="absolute inset-0 w-full h-full md:h-[calc(100%+100px)] object-cover object-center md:-top-[50px] will-change-transform"
      />

      <div className="absolute inset-0 bg-black/40 z-[1]" />

      <div className="relative z-[2] flex items-center justify-center h-full">
        <div className="w-12 h-[2px] bg-[#FFD700]/40" />
      </div>
    </div>
  );
}